npm<template>
    <div class='wrap'>
        <boao-head></boao-head>
        <div class='titleBox'>
            <span class="title">{{item.title}}</span>
            <img class='down' src="./../../../assets/Mobile/Boao/downL.gif" alt="">
            <p class='date'>
                图片来源：博鳌亚洲论坛   发布时间：2019-06-11 17:23:39  
                浏览次数：765
            </p>
        </div>
        <div class='content'>
            <img class='conImg' :src="item.image" alt="">
            <p class='context'>
                6月10日，博鳌亚洲论坛秘书长、外交部原副部长李保东先生出席博鳌亚洲论坛全球健康论坛大会博览会开幕式。李保东秘书长表示，发起成立全球健康论坛并举办此次大会，旨在搭建一个在全球具有广泛代表性和权威性的政商学结合、高端对话与务实合作的综合性平台，促进全球健康事业和健康产业的发展。<br><br>
                此次大会分论坛一汇聚了世界卫生组织、全球医生组织、国内医疗监管部门、全国排名靠前医院、医疗信息建设行业主要企业等单位的代表，紧扣「创新促进健康——互联网医疗的未来」分论坛主题，就互联网医疗的现状、未来发展前景、存在问题、解决措施、5G重大影响等方面进行了充分探讨，并提出了众多政策建议。<br/><br/>
                {{item.content}}
            </p>
        </div>
    </div>
</template>

<script>
import BoaoHead from '@/components/Mobile/BoaoHead.vue'
export default {
    components:{
        BoaoHead
    },
    data() {
        return{
        }
    },
    created () {
    },
    computed: {
        item: function () {
            return this.$route.query.item
        }
    }
};
</script>

<style type="text/less" lang="less" scoped>
.wrap{
    // min-height:100vh;
}
.titleBox{
    font-size:28px;
    font-family:NotoSansHans-Medium;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:36px; 
    text-align:center;
    // margin-bottom:34px;
    .title{
        width: 637px;
        display:block;
        margin: 0 auto;
    }
    .down{
        width: 46px; display: block; margin:30px auto 60px; 
    }
    .date{
        font-size:24px;
        font-family:NotoSansHans-Light;
        font-weight:300;
        color:rgba(102,102,102,1);
        line-height:48px;
        width:655px; text-align:center;
        margin: 0 auto 57px;
    }
}
.content{
    width: 637px;
    margin: 0 auto 138px;
    .conImg{
        height: 426px; display: block;
        width: 100%;
         margin-bottom:44px;
    }
    .context{
        font-size:24px;
        font-family:NotoSansHans-DemiLight;
        font-weight:normal;
        padding: 0 5px;
        color:rgba(51,51,51,1);
        line-height:36px;
    }
}
</style>